export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/ob-step-6.png?7ed9b7366256e0b7826ab4e1efc5eb06";